// AMA Guides 5th ed — Table 16-3 (p. 439): Upper Extremity Impairment (UE%) →
// Whole Person Impairment (WPI%). Transcribed VERBATIM from the printed table and
// verified 2026-07-16 (errata reviewed — no erratum touches Table 16-3). Index = UE%,
// value = WPI%. This transcribed lookup is the SINGLE SOURCE OF TRUTH for the UE→WPI
// conversion in the ratings engine — never the `round(UE × 0.6)` shortcut (it happens
// to reproduce the printed table at every spot-checked value, but the book governs).
//
// Sanity anchors from the printed table: 6→4, 8→5, 12→7, 14→8, 16→10, 24→14, 100→60.
//
// ZERO imports on purpose — node verify gates import this via relative-.ts paths under
// `node --experimental-strip-types` (an extensionless or `@/` import would break there).
export const TABLE_16_3: readonly number[] = [
  0, 1, 1, 2, 2, 3, 4, 4, 5, 5, 6, 7, 7, 8, 8, 9, 10, 10, 11, 11, 12, 13, 13, 14, 14,
  15, 16, 16, 17, 17, 18, 19, 19, 20, 20, 21, 22, 22, 23, 23, 24, 25, 25, 26, 26, 27,
  28, 28, 29, 29, 30, 31, 31, 32, 32, 33, 34, 34, 35, 35, 36, 37, 37, 38, 38, 39, 40,
  40, 41, 41, 42, 43, 43, 44, 44, 45, 46, 46, 47, 47, 48, 49, 49, 50, 50, 51, 52, 52,
  53, 53, 54, 55, 55, 56, 56, 57, 58, 58, 59, 59, 60,
];

/**
 * Convert an upper-extremity impairment (UE%) to whole-person impairment (WPI%) via
 * the transcribed Table 16-3 lookup. Non-integer input is rounded to the nearest
 * integer before lookup; the index is clamped to [0, 100].
 */
export function ueToWpi(ue: number): number {
  if (!Number.isFinite(ue)) return 0;
  const idx = Math.min(100, Math.max(0, Math.round(ue)));
  return TABLE_16_3[idx];
}

// AMA Guides 5th Edition — Table 17-3. Copied verbatim from QME - Tool.
export const TABLE_17_3: readonly number[] = [
  0, 0, 1, 1, 2, 2, 2, 3, 3, 4, 4, 4, 5, 5, 6, 6, 6, 7, 7, 8, 8, 8, 9, 9, 10,
  10, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 16, 16, 16, 17, 17,
  18, 18, 18, 19, 19, 20, 20, 20, 21, 21, 22, 22, 22, 23, 23, 24, 24, 24, 25,
  25, 26, 26, 26, 27, 27, 28, 28, 28, 29, 29, 30, 30, 30, 31, 31, 32, 32, 32,
  33, 33, 34, 34, 34, 35, 35, 36, 36, 36, 37, 37, 38, 38, 38, 39, 39, 40, 40,
];

/** Convert a lower-extremity impairment % to whole-person % (clamp 0-100, round non-integers). */
export function leToWpi(le: number): number {
  const idx = Math.max(0, Math.min(100, Math.round(le)));
  return TABLE_17_3[idx];
}

